export const socialAuthOptions = [
    "google",
    "apple",
    "facebook",
    "discord",
    "farcaster",
    "telegram",
];
export const authOptions = [
    ...socialAuthOptions,
    "email",
    "phone",
    "passkey",
];
//# sourceMappingURL=types.js.map